import { AlteGoEnv } from "../altego/AlteGoEnv";
import manifest from "./altego-dev-manifest.json";

export class AlteGoDevEnv extends AlteGoEnv {
	static manifest = manifest;
}

new AlteGoDevEnv();
